import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { CONTACT } from "@/data/content";
import { MaskLines, Reveal } from "@/components/motion";

export default function PtsBlock() {
  return (
    <section data-testid="pts-section" className="relative bg-[#070A12] py-24 sm:py-32 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
        <div className="relative border border-red-400/25 bg-gradient-to-br from-[#1a0d14] via-[#0B1120] to-[#0B1120] p-8 sm:p-14 lg:p-20 overflow-hidden">
          <div className="absolute -right-24 -top-24 w-[420px] h-[420px] rounded-full bg-red-600/20 blur-[120px] pointer-events-none" />
          <div className="relative grid lg:grid-cols-12 gap-12 items-end">
            <div className="lg:col-span-7">
              <p className="font-data text-[11px] tracking-[0.28em] uppercase text-red-300 flex items-center gap-3 mb-6">
                <span className="pulse-dot w-2 h-2 rounded-full bg-red-500" /> Immediate post-trauma service
              </p>
              <h2 className="font-display text-5xl sm:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-slate-50">
                <MaskLines lines={["PTS,", "not PTSD."]} lineClassName="" />
              </h2>
              <Reveal delay={0.2}>
                <p className="mt-8 max-w-xl text-sm sm:text-lg text-slate-300 leading-relaxed">
                  After an acute incident, time matters. We provide same-day or acute intervention within hours or days — to stop PTSD before it develops.
                </p>
              </Reveal>
            </div>
            <Reveal delay={0.3} className="lg:col-span-5 flex flex-col gap-4">
              <Link to="/immediate-support" data-testid="pts-request-support-button" className="group inline-flex items-center justify-between gap-3 px-7 py-5 bg-red-500/90 hover:bg-red-500 text-white text-sm font-medium tracking-wide transition-colors duration-300">
                Request Immediate Support
                <ArrowUpRight className="w-4 h-4 transition-transform duration-500 group-hover:rotate-45" />
              </Link>
              <div data-testid="pts-triage-hotline" className="flex items-center gap-4 px-7 py-5 border border-white/15 text-slate-200 text-sm">
                <Phone className="w-4 h-4 text-red-300" /> Triage line: <span className="font-data">{CONTACT.triage}</span>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
